import React from 'react'

export function LayoutContentOpen (props) {
  const { children, className } = props
  return (
    <div className={className}>
      {children}
    </div>
  )
}

export default LayoutContentOpen
